import { DiagramDefinition } from "../types";

export const m014Definition: DiagramDefinition = {
  id: "M-014",
  title: "Realtime Subscription State Diagram",
  description:
    "State machine for client realtime connections: Connecting, Open, Subscribed, and Closed states with onopen, subscribe, unsubscribe, and onclose events.",
  viewBox: "0 0 800 320",
  nodes: [
    { id: "Connecting", kind: "service", label: "Connecting", subtext: "Handshake", position: [180, 160], size: [130, 48] },
    { id: "Open", kind: "service", label: "Open State", subtext: "Ready for Sub", position: [380, 160], size: [130, 48] },
    { id: "Subscribed", kind: "service", label: "Subscribed", subtext: "Active Topics", position: [580, 160], size: [140, 48] },
    { id: "Closed", kind: "status", label: "Closed State", subtext: "Disconnected", position: [380, 270], size: [130, 44], statusColor: "#ef4444" },
  ],
  edges: [
    { id: "e1", source: "Connecting", target: "Open", label: "onopen", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "Open", target: "Subscribed", label: "subscribe", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e3", source: "Subscribed", target: "Open", label: "unsubscribe", sourcePort: "left", targetPort: "right", routing: "orthogonal", midOffset: 110 },
    { id: "e4", source: "Connecting", target: "Closed", label: "refused", sourcePort: "bottom", targetPort: "left", routing: "orthogonal" },
    { id: "e5", source: "Open", target: "Closed", label: "onclose", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e6", source: "Subscribed", target: "Closed", label: "disconnect", sourcePort: "bottom", targetPort: "right", routing: "orthogonal" },
  ],
};
